import Odometer from "odometer";

export const initAnimations = () => {
	initStatRolling();
	addAnimationClassToLogo();
};

const initStatRolling = () => {
	if (!document.querySelector(".rolling-stat")) return;

	const rollingStats = document.querySelectorAll(".rolling-stat");

	setTimeout(() => {
		rollingStats.forEach((stat) => {
			observer.observe(stat);
		});
	}, 1000);

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const odometer = new Odometer({
						el: entry.target,
						value: 0,
						format: "(,ddd).dd",
						duration: 2000,
						theme: "minimal",
					});
					odometer.render();
					odometer.update(entry.target.dataset.statNumberValue);
					observer.unobserve(entry.target);
				}
			});
		},
		{
			rootMargin: "0px",
			threshold: 0.5,
		}
	);
};

// create a cookie for set for an hour to check if already animated logo
// if not animated, animate the logo
const addAnimationClassToLogo = () => {
	// check for cookie
	const cookie = document.cookie.split(";");
	const hasAnimatedLogo = cookie.some((c) => c.includes("animatedLogo"));
	const logo = document.querySelector(".logo");
	if (!logo) return;
	if (hasAnimatedLogo) {
		logo.classList.add("already-animated");
		return;
	}

	logo.classList.add("animate");
	// create a cookie for set for an hour to check if already animated logo
	// if not animated, animate the logo
	const date = new Date();
	date.setTime(date.getTime() + 3600000); // 1 hour
	document.cookie = `animatedLogo=true; expires=${date.toUTCString()}; path=/`;
};
